﻿<div class="flex min-h-screen min-w-0 flex-col">

    <div>
        <mat-toolbar>
            <mat-toolbar-row>
                <button matMiniFab (click)="drawer.toggle()" aria-label="Toggle navigation">
                    <mat-icon>menu</mat-icon>
                </button>
                <h1 class="min-w-0 flex-1 truncate px-2 text-center text-lg font-bold">{{vm.title}}</h1>
                @if(vm.testSite) { <div class="text-error bg-outline-variant rounded p-2">Test Site</div> }
                @if(vm.localHost) { <div class="text-error bg-outline-variant rounded p-2">Localhost</div> }
                <mce-profile class="shrink-0" />
            </mat-toolbar-row>
        </mat-toolbar>
    </div>

    <div class="min-w-0 flex-1">
        <mat-drawer-container class="w-full min-w-0">
            <mat-drawer #drawer
                        class="w-[85vw] max-w-[280px]"
                        [mode]="vm.matDrawerMode"
                        [opened]="vm.matDrawerOpened">
                <div class="bg-surface-container flex min-h-[calc(100vh-76px)] flex-col justify-between pb-4">
                    <div class="flex-grow"><mce-navigation></mce-navigation></div>
                </div>
            </mat-drawer>
            <mat-drawer-content class="min-h-[calc(100vh-72px)] min-w-0 px-4 py-6">
                <ng-content></ng-content>
            </mat-drawer-content>
        </mat-drawer-container>

    </div>

</div>
